import { FlexContext } from '#app/components/Layout/components/Flex/context.js';
import { StyledCol } from './Col.styles.js';
import { type ColProps } from './types.js';
import { useContext } from 'react';

export const Col = ({
  children,
  defaultOffset,
  defaultSize,
  // This spread should only be ColSizeProps
  ...breakpointProps
}: ColProps) => {
  const { gap } = useContext(FlexContext);

  return (
    <StyledCol
      $gap={gap}
      $offset={defaultOffset}
      $size={defaultSize}
      {...breakpointProps}
    >
      {children}
    </StyledCol>
  );
};

Col.displayName = 'Flex.Col';
